if (!window.scriptLoaded) {
    window.scriptLoaded = true;

    const showContent = (e) => {
      e.preventDefault();
      const parentElement = e.target.parentElement.parentElement;
      const showcontents = parentElement.nextElementSibling;
      const hideText = e.target.nextElementSibling
      showcontents.classList.remove('hidden')
      e.target.classList.add('hidden')
        hideText.classList.remove('hidden')
       
      };

     const hideContent = (e) => {
  e.preventDefault();
  const parentElement = e.target.parentElement.parentElement;
  const showcontents = parentElement.nextElementSibling;
  const hideText = e.target.parentElement;
  
  const showText = hideText.closest('div').querySelector('.ImageWithText__primary');
    showText.classList.remove('hidden')
  showcontents.classList.add('hidden')
    e.target.classList.add('hidden')
  };


    document.addEventListener('DOMContentLoaded', function() {
      const showstudiesSelectors = document.querySelectorAll('.ImageWithText__primary');
        showstudiesSelectors.forEach((showstudiesSelector) => {
        showstudiesSelector.addEventListener('click', showContent);
      });

      const hidestudiesSelectors = document.querySelectorAll('.ImageWithText__secondary');
      hidestudiesSelectors.forEach((hidestudiesSelector) => {
        hidestudiesSelector.addEventListener('click', hideContent);
      });
  });
}
 




